<script setup lang="ts">import { computed as _computed } from 'vue';

import type {Component} from 'vue'

import {NotificationItemContentType} from '../enum/NotificationItemContentType'
import DatabaseItemValueNotificationItemContentTypeStrategy from '../strategies/notificaitonItemContentTypeStrategies/DatabaseItemValueNotificationItemContentTypeStrategy.vue'
import MessageNotificationItemContentTypeStrategy from '../strategies/notificaitonItemContentTypeStrategies/MessageNotificationItemContentTypeStrategy.vue'
interface Props {
  contentType: NotificationItemContentType
  payload: unknown
 createdAt: Date
}

const props = defineProps<Props>()

const strategyMap = new Map<NotificationItemContentType, Component>([
  [NotificationItemContentType.DatabaseItemValue, DatabaseItemValueNotificationItemContentTypeStrategy],
  [NotificationItemContentType.Message, MessageNotificationItemContentTypeStrategy],
])

const strategyComponent = _computed<Component>(() => {
  return strategyMap.get(props.contentType) 
})


</script>

<template>
  <Component
    v-if="strategyComponent"
    :is="strategyComponent"
    :payload="props.payload"
    :createdAt="props.createdAt"
  />
</template>
